import { render } from "./listMyCall.vue?vue&type=template&id=5b793f1e&scoped=true"
import script from "./listMyCall.vue?vue&type=script&lang=js"
export * from "./listMyCall.vue?vue&type=script&lang=js"

import "./listMyCall.vue?vue&type=style&index=0&id=5b793f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b793f1e"]])

export default __exports__